module.exports = __webpack_public_path__ + "img/ic_qrcode_youbute.fc5abb4.webp";